'use client';

import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { FC, useState } from 'react';
import Loader from '~/components/loading';
import FormSuccessModal from '~/data/strapi/types/shared-blocks/block-customer-form/success-modal';
import CustomerFormAcceptModal from '~/features/customer-form/accept-modal';

import styles from './styles.module.css';

const CustomerForm = dynamic(() => import('~/features/customer-form'), {
  loading: () => <Loader />,
});

interface Props {
  description: TrustedHTML | null;
  buttonTitle: string | null;
  agreementText: TrustedHTML | null;
  successModalData: FormSuccessModal | null;
}

const Form: FC<Props> = (formProps) => {
  const [show, setShow] = useState<boolean>(false);
  const pathname = usePathname();
  const { successModalData } = formProps;

  const showSuccessModal = () => {
    window.history.replaceState({}, '', `${pathname}#formSuccess`);
    setShow(true);
  };

  const hideSuccessModal = () => {
    window.history.replaceState({}, '', `${pathname}`);
    setShow(false);
  };

  return (
    <>
      <CustomerForm className={styles.form} onSuccess={showSuccessModal} onError={hideSuccessModal} {...formProps} />
      {successModalData && (
        <CustomerFormAcceptModal visible={show} onClose={hideSuccessModal} data={successModalData} />
      )}
    </>
  );
};

export default Form;
